import { TrustLayerCard } from './TrustLayerCard';
import { trustLayers } from '../data/trustLayers';
import { useI18n } from '../i18n/useI18n';
import { trustVisualAsset } from '../data/websiteAssets';

export function TrustLayersSection() {
  const { t } = useI18n();

  return (
    <section className="section" id="trust-layers">
      <div className="section-heading">
        <p className="eyebrow">{t('trust.eyebrow')}</p>
        <h2>{t('trust.title')}</h2>
        <p>{t('trust.text')}</p>
      </div>
      <picture className="wide-visual trust-visual">
        <source srcSet={trustVisualAsset.webp} type="image/webp" />
        <img
          src={trustVisualAsset.png}
          alt={t('trust.visualAlt')}
          loading="lazy"
          width="1672"
          height="941"
        />
      </picture>
      <div className="trust-grid">
        {trustLayers.map((item) => (
          <TrustLayerCard item={item} key={item.id} />
        ))}
      </div>
    </section>
  );
}
